import React, { useEffect, useState } from 'react';
import DescriptionDetails from '../../components/description-details';
import { formatDate } from '../../components/formatters';
import { isObjectModified } from '../../components/property-mapper';
import CompareAddress from './compare-address';
import CompareField from './compare-field';

const Employee = ({modified, unmodified}) => {
    const [isModified, setIsModified] = useState();

    useEffect(() => {
        setIsModified(isObjectModified(modified, unmodified));
        
    }, [])
    return ( 
        <div className="mb-4">
            <div className='text-xl mb-2'>
                <span className={isModified ? 'text-purple' : 'text-danger'}>Employee</span>
            </div>
            <CompareField title="First Name" modifiedValue={modified.firstName} unmodifiedValue={unmodified.firstName} />
            <CompareField title="Last Name" modifiedValue={modified.lastName} unmodifiedValue={unmodified.lastName} />
            <div className="print:hidden">
            <CompareField title="Social Security Number" modifiedValue={modified.ssn} unmodifiedValue={unmodified.ssn} />
            </div>
            <CompareField title="Date of Birth" modifiedValue={formatDate(modified.birthdate)} unmodifiedValue={formatDate(unmodified.birthdate)} />
            <CompareAddress title="Address" modified={modified} unmodified={unmodified} />
            <CompareField title="Gender" modifiedValue={modified.gender?.name} unmodifiedValue={unmodified.gender?.name} />
            <CompareField title="Marital Status" modifiedValue={modified.maritalStatus?.name} unmodifiedValue={unmodified.maritalStatus?.name} />
           <hr />
        </div>
     );
}
 
export default Employee;